import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App.js'

const host = document.getElementById('root')
if (!host) throw new Error('The page has no #root element to mount into.')

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
